import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useApiQuery } from '../../../../../../api/hooks';
import ParticipantCard from './ParticipantCard';
import ParticipantDetailModal from './ParticipantDetailModal';
// Панель «Участники»: карточки подтвердивших участие, отсортированные по всего заработанному (больше — выше), клик открывает детали.
export default function ParticipantsPanel({ smenaId, qrBaseUrl }) {
    const { data: participants = [], isLoading } = useApiQuery(
        ['neighbor', 'participants', smenaId],
        `/api/neighbor/admin/participants/list-confirmed?smenaId=${smenaId}`,
        { refetchOnMount: 'always', enabled: !!smenaId }
    );
    const [selected, setSelected] = useState(null);

    const sorted = [...participants].sort((a, b) => (b.totalBalance ?? 0) - (a.totalBalance ?? 0));

    return (
        <div className="bt-panel">
            <div className="ev-head">
                <h2>Участники <span className="fr-cnt">({sorted.length})</span></h2>
            </div>
            {isLoading ? (
                <div className="bt-empty">Загрузка…</div>
            ) : sorted.length > 0 ? (
                <div className="sp-partgrid">
                    {sorted.map((p, index) => (
                        <ParticipantCard key={p.userId} participant={p} index={index} onSelect={setSelected} />
                    ))}
                </div>
            ) : <div className="bt-empty">Нет участников, подтвердивших участие</div>}

            {selected && (
                <ParticipantDetailModal participant={selected} smenaId={smenaId} qrBaseUrl={qrBaseUrl} onClose={() => setSelected(null)} />
            )}
        </div>
    );
}

ParticipantsPanel.propTypes = {
    smenaId: PropTypes.number.isRequired,
    qrBaseUrl: PropTypes.string
};

ParticipantsPanel.defaultProps = { qrBaseUrl: null };
